import { AppState } from '../../store';

export const getTransactionsListSelector = (state: AppState) => state.transactions.transactions;
export const getCurrencyInfoSelector = (state: AppState) => state.transactions.currencyInfo;
export const getCurrencyTransfersListSelector = (state: AppState) =>
  state.transactions.currencyTransfers;
export const getLastTransactionTimeUpdate = (state: AppState) =>
  state.transactions.transactionsListUpdated;
export const getLastCurrencyTimeUpdate = (state: AppState) =>
  state.transactions.transactionsListUpdated;
export const getCurrencyInfoArraySelector = (state: AppState) => [state.transactions.currencyInfo];
